export default "/images/searching-adm.svg?f4208ebdb95345de650875eaecbefa79";